<template>
  <div class="footer">
    <div class="columns">
      <div class="column">
        <h4><img alt="logo" src="../assets/flatte.png"></h4>
        <p class="logo_subtitle">テキスト・ストリーミングのサイト</p>
      </div>
      <div class="column">
        <h4>About</h4>
        <p><a href="https://twitter.com/katonobo1">運営者ツイッター</a></p>
      </div>
      <div class="column">
        <h4>Legal</h4>
        <router-link :to="{ name: 'Privacy' }">プライバシーポリシー</router-link>
      </div>
      <div class="column">
        <h4>Links</h4>
        <a href="https://www.aozora.gr.jp/">青空文庫</a>
      </div>
    </div>
    <hr class="footer_line">
    <p class="footer_title">@ Flatte</p>
  </div>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style scoped>
h4 {
    display: block;
    margin-block-start: 1.33em;
    margin-block-end: 1.33em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
    margin:10px 0;
}
.footer{
  background-color: white;
}
.footer_line{
  margin-top:24px;
  margin-bottom:24px;
}
.footer_title{
  text-align: center;
  font-size: 0.8em;
  color: gray;
}
.logo_subtitle{
  font-size: 0.8em;
  color: gray;
}
</style>
